module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"signIn":"Sign In","signOut":"Sign Out"},"de":{"signIn":"Anmelden","signOut":"Abmelden"}}')
  delete Component.options._Ctor
}
